let fbAnalyticsContext = {
    user: null,
    lastPath: null,
};

async function setFbAnalyticsUser(user, profile) {
    try {
        const em = user?.email;
        const external_id = user?.userId;
        const fn = profile?.firstName;
        const ln = profile?.lastName;
        const ge =
            profile?.gender === null || profile?.gender === undefined
                ? ''
                : profile.gender === 0
                ? 'f'
                : 'm';
        fbAnalyticsContext.user = {
            em,
            fn,
            ln,
            ge,
            external_id,
        };
        const fbq =
            typeof window !== 'undefined' && typeof window.fbq === 'function' ? window.fbq : null;
        if (!fbq || typeof fbq.getState !== 'function' || !fbq.instance) return;
        const pixelIds = fbq.getState()?.pixels?.map((pixel) => pixel.id) ?? [];
        Object.entries(fbAnalyticsContext.user).forEach(([key, value]) => {
            if (!value) return;
            pixelIds.forEach((pixelId) => {
                const pixel = fbq.instance.pixelsByID?.[pixelId];
                if (!pixel) return;
                if (!pixel.userData) pixel.userData = {};
                pixel.userData[key] = value;
            });
        });
    } catch (e) {
        // pixel internals are a private API — best-effort
    }
}

function clearFbAnalyticsUser() {
    fbAnalyticsContext.user = null;
    try {
        const fbq =
            typeof window !== 'undefined' && typeof window.fbq === 'function' ? window.fbq : null;
        if (!fbq || typeof fbq.getState !== 'function' || !fbq.instance) return;
        const pixelIds = fbq.getState()?.pixels?.map((pixel) => pixel.id) ?? [];
        pixelIds.forEach((pixelId) => {
            const pixel = fbq.instance.pixelsByID?.[pixelId];
            if (pixel) pixel.userData = {};
        });
    } catch (e) {
        // pixel internals are a private API — best-effort
    }
}

function trackEvent(eventName, params = {}) {
    const fbq = window.fbq;

    if (fbq !== 'undefined' && typeof fbq === 'function') {
        let eventType = 'track';
        let checkedEventName = '';

        if (Object.values(eventMap).includes(eventName)) {
            checkedEventName = eventName;
        }
        if (Object.values(customEventMap).includes(eventName)) {
            checkedEventName = eventName;
            eventType = 'trackCustom';
        }

        if (checkedEventName !== undefined) {
            fbq(eventType, checkedEventName, { ...params });
        }
    }
}

function trackPageView(path) {
    if (fbAnalyticsContext.lastPath === path) return;

    fbAnalyticsContext.lastPath = path;

    trackEvent('PageView');
}

const eventMap = {
    addToCart: 'AddToCart',
    initiateCheckout: 'InitiateCheckout',
    completeRegistration: 'CompleteRegistration',
    contact: 'Contact',
    viewContent: 'ViewContent',
    purchase: 'Purchase',
    subscribe: 'Subscribe',
    pageView: 'PageView',
};

const customEventMap = {
    notRecurringPayment: 'zakup bez rat',
    recurringPayment: 'zakup ratalny',
};

export {
    trackEvent,
    eventMap,
    customEventMap,
    setFbAnalyticsUser,
    trackPageView,
    clearFbAnalyticsUser,
};
